import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LayoutModule } from '../../layout/layout.module';
import { LoginComponent } from '../login/login.component';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [CommonModule, LayoutModule, LoginComponent],
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent {
}
